import { render, staticRenderFns } from "./videolistInner.vue?vue&type=template&id=4482006f&scoped=true&"
import script from "./videolistInner.vue?vue&type=script&lang=js&"
export * from "./videolistInner.vue?vue&type=script&lang=js&"
import style0 from "./videolistInner.vue?vue&type=style&index=0&id=4482006f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482006f",
  null
  
)

export default component.exports